var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3C80F1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.084 4c-5.47.004-9.904 4.436-9.91 9.905.005.534.065 1.066.178 1.588a.154.154 0 00.24.09 2.236 2.236 0 011.298-.418.152.152 0 00.155-.177 6.04 6.04 0 01-.102-1.072 8.14 8.14 0 1116.28 0c0 4.49-5.744 10.225-7.8 12.25a.484.484 0 01-.678 0 60.771 60.771 0 01-2.533-2.625h-.04a8.625 8.625 0 01-2.295-.55l-.136-.055a.152.152 0 00-.179.237 57.5 57.5 0 004.047 4.357 2.109 2.109 0 002.945 0c3.62-3.576 8.44-8.866 8.44-13.625-.006-5.47-4.44-9.901-9.91-9.905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.204 14.907c0 .14-.011.277-.024.413a4.805 4.805 0 01-.357 1.514c-.216.48-.504.923-.853 1.316l.01.009a7.025 7.025 0 01-2.5 1.786 6.216 6.216 0 01-3.003.482A5.557 5.557 0 0110.77 19.4c.257-.008.512-.047.76-.116a2.59 2.59 0 00.638-.273 2.288 2.288 0 00.952-1.116c.087-.213.146-.435.178-.663.02-.19.025-.383.018-.575v-6.49a.13.13 0 010-.019v-.034a.377.377 0 01.321-.305h2.143c.508.04 1.005.173 1.465.393a5.334 5.334 0 012.303 2.093c.132.224.248.458.345.7.093.24.167.49.22.742.053.252.083.508.09.765v.406zm1.764-.466a6.018 6.018 0 00-.129-1.071 6.509 6.509 0 00-.776-1.977A7.093 7.093 0 0017.986 8.6a5.91 5.91 0 00-2.084-.554c-.091 0-.179 0-.279-.01h-1.998c-.064 0-.13 0-.195.014-.261.03-.515.11-.748.234a2.143 2.143 0 00-1.128 1.743v6.63c0 .116-.008.232-.024.347-.01.078-.029.154-.057.228a.568.568 0 01-.09.152.675.675 0 01-.344.198c-.197.05-.4.066-.603.047a3.35 3.35 0 01-1.941-.868.884.884 0 00-1.377 1.071 9.273 9.273 0 002.514 2.923 7.455 7.455 0 001.736.965 7.296 7.296 0 001.937.464 7.982 7.982 0 003.863-.604 8.241 8.241 0 003.137-2.287l.011.009a6.929 6.929 0 001.14-1.773 6.573 6.573 0 00.485-2.065c.014-.178.023-.339.029-.509v-.251c.007-.074.001-.175 0-.263h-.002z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDth);
export default __webpack_public_path__ + "static/media/dth.ae8002cd10df370106b892e365a7d8d3.svg";
export { ForwardRef as ReactComponent };